module.exports = __webpack_public_path__ + "img/icon-help-button.77398f42.svg";